import React from 'react';
import { NavLink } from 'react-router-dom';

import Button, { buttonType, buttonColor } from 'Components/Button';
import EditApplicationButton from 'Components/EditApplicationButton';

import {ACTION} from '../../../../../constants';

export default class ChangeStatus extends React.Component {
  isActionAllowed = actionKey => {
    const {availableActions} = this.props;
    return availableActions.find(act => act === actionKey);
  };

  performAction = actionKey => () => {
    const {updateListEntry, deleteListEntry, selectAction, applicationData} = this.props;

    selectAction(actionKey, applicationData)
      .then(updatedData => {
        if (actionKey !== ACTION.DELETE) updateListEntry(updatedData);
        else deleteListEntry();
      });
  };

  getApproveButton = () => {
    if (this.isActionAllowed(ACTION.APPROVE))
      return (
        <Button
          label='Approve'
          buttonClassName='_height_40 _width_120 _margin_right_25  _margin_top_30'
          onClick={this.performAction(ACTION.APPROVE)}
          type={buttonType.primary}
          color={buttonColor.green}
        />
      );
    return null;
  };

  getDeactivateButton = () => {
    if (this.isActionAllowed(ACTION.DEACTIVATE))
      return (
        <Button
          label='Deactivate'
          buttonClassName='_height_40 _width_120 _margin_right_25  _margin_top_30'
          onClick={this.performAction(ACTION.DEACTIVATE)}
          color={buttonColor.red}
        />
      );
    return null;
  };

  getIncompleteButton = () => {
    if (this.isActionAllowed(ACTION.INCOMPLETE))
      return (
        <Button
          label='Incomplete'
          buttonClassName='_height_40 _width_120 _margin_right_25  _margin_top_30'
          onClick={this.performAction(ACTION.INCOMPLETE)}
          type={buttonType.primary}
          color={buttonColor.lightBlue}
        />
      );
    return null;
  };

  getSubmitButton() {
    if (this.isActionAllowed(ACTION.RESUBMIT))
      return (
        <Button
          label='Submit'
          buttonClassName='_height_40 _width_120 _margin_right_25  _margin_top_30'
          onClick={this.performAction(ACTION.RESUBMIT)}
          type={buttonType.primary}
          color={buttonColor.orange}
        />
      );
    return null;
  }

  getRolloverButton() {
    if (this.isActionAllowed(ACTION.ROLL_OVER))
      return (
        <React.Fragment>
          <Button
            label='Roll Over'
            buttonClassName='_height_40 _width_120 _margin_right_25  _margin_top_30'
            iconClassName='rollover-icon'
            onClick={this.performAction(ACTION.ROLL_OVER)}
            color={buttonColor.green}
          />
        </React.Fragment>
      );

    return null;
  }

  getESignButton() {
    if (this.isActionAllowed(ACTION.E_SIGN_AGREEMENT))
      return (
        <React.Fragment>
          <Button
            label={ACTION.E_SIGN_AGREEMENT}
            buttonClassName='_height_40 _width_160 _margin_right_25  _margin_top_30'
            onClick={this.performAction(ACTION.E_SIGN_AGREEMENT)}
            color={buttonColor.green}
          />
        </React.Fragment>
      );

    return null;
  }

  render() {
    const {availableActions, applicationId, user} = this.props;
    const eSignActionsList = [this.getESignButton()].filter(button => button);
    const rollOwerActionsList = [this.getRolloverButton()].filter(button => button);
    const statusActionList = [
      this.getDeactivateButton(),
      this.getIncompleteButton(),
      this.getSubmitButton(),
      this.getApproveButton(),
    ].filter(button => button);

    if (!(eSignActionsList.length + rollOwerActionsList.length + statusActionList.length)) return null;

    const firstDelimiterNeeded = eSignActionsList.length && (rollOwerActionsList.length || statusActionList.length);
    const secondDelimiterNeeded = rollOwerActionsList.length && statusActionList.length;

    const link = `/${user.getManufacturerCode()}/oil/brand/${applicationId}/edit`;

    return (
      <section className='scene_section detailsScene__change-status-section'>
        <header>Actions</header>
        {availableActions.includes(ACTION.EDIT) && (
          <NavLink to={link}>
            <EditApplicationButton className='_height_40 _width_pc_100 _max_width_180 _margin_top_30 _margin_right_30' />
          </NavLink>
        )}
        {eSignActionsList}

        {!!firstDelimiterNeeded && <div className='__delimiter_vertical' />}

        {rollOwerActionsList}

        {!!secondDelimiterNeeded && <div className='__delimiter_vertical' />}

        {statusActionList}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/OilManufacturer/brand/Application/Details/ChangeStatus.jsx